import {
  getApplicationWorkListById,
  getApplicationWorkLists,
  getPermitById,
} from './services/permitting-api';

const SET_PERMIT = 'permitting/SET_PERMIT';
const GET_APPLICATIONWORKLISTS = 'permitting/GET_APPLICATIONWORKLISTS';
const SET_APPLICATIONWORKLISTS = 'permitting/SET_APPLICATIONWORKLISTS';

const permittingStore = {
  state: {
    permit: {},
    applicationWorkLists: [],
    facilityType: null,
  },
  mutations: {
    [SET_PERMIT](state, permit) {
      state.permit = permit;
    },
    [SET_APPLICATIONWORKLISTS](state, data) {
      state.applicationWorkLists = data;
    },
  },
  getters: {
    permit: (state) => state.permit,
    applicationWorkLists: (state) => state.applicationWorkLists,
  },
  actions: {
    // eslint-disable-next-line consistent-return
    [SET_PERMIT]: async ({ commit }, data) => {
      try {
        let permit = data?.permit;
        const ePermitId = data?.ePermitId;
        if (permit) {
          commit(SET_PERMIT, permit);
        } else if (ePermitId) {
          return await getPermitById(ePermitId)
            .then((resp) => {
              commit(SET_PERMIT, resp.data[0]);
            });
        } else {
          permit = {
            applicationDate: new Date(),
            requestDate: new Date(),
            requestor: '',
            requestorEmail: '',
            applicationUserId: '',
            municipality: '',
            municipalityId: 0,
            foip: false,
            isOwnerSameApplicant: false,
            isContractorSameApplicant: false,
            isEngineerSameApplicant: false,
            otherPermitBuilding: false,
            otherPermitElectrical: false,
            otherPermitGas: false,
            otherPermitPSDS: false,
            otherPermitPlumbing: false,
            valueOfInstallation: 0.0,
            propertyInsurer: '',
            policyNo: '',
            isOilRemovalCompany: false,
            abovegroundFuelSupply: false,
            applicantContact: {
              phone: null,
              email: null,
              altPhone: '',
            },
            applicantCompany: {
            },
            contractorCompany: {
            },
            contractorContact: {
              phone: null,
              email: null,
              altPhone: '',
            },
            engineerCompany: {
            },
            engineerContact: {
              phone: null,
              email: null,
              altPhone: '',
            },
            installerCompany: {
            },
            installerContact: {
              comments: '',
              phone: null,
              email: null,
              altPhone: '',
            },
            ePermitSite: {
              isWorkNotStarted: false,
              isWorkInProgress: false,
              isWorkCompleted: false,
              ownerCompany: {
              },
              ownerContact: {
                fName: null,
                lName: null,
                phone: null,
                email: null,
                altPhone: '',
              },
              siteAddress: {
              },
              eSiteTanks: [],
            },
          };
          commit(SET_PERMIT, permit);
        }
      } catch (error) {
        console.error(`get-permitbyid_err:${error.Status}`);
        throw error;
      }
    },
    [GET_APPLICATIONWORKLISTS]: async ({ commit }, ePermitId) => {
      if (ePermitId) {
        // eslint-disable-next-line no-return-await
        return await getApplicationWorkListById(ePermitId).then((res) => {
          var list = res.data?.filter(x => x.question !== "Please confirm the following work to be completed:");
          commit(SET_APPLICATIONWORKLISTS, list);
        });
      }
      // eslint-disable-next-line no-return-await
      return await getApplicationWorkLists().then((res) => {
        var list = res.data?.filter(x => x.question !== "Please confirm the following work to be completed:");
        commit(SET_APPLICATIONWORKLISTS, res.data);
      });
    },
  },
};

export {
  SET_PERMIT,
  GET_APPLICATIONWORKLISTS,
  permittingStore,
};
